// extracted by mini-css-extract-plugin
export default {"wrapper":"md","form":"nd","smallprint":"od","asterisk":"pd","success":"qd","circle":"rd","button":"sd"};